import { Fragment, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Form, Modal, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../../tool/axios'

interface Prop {
    customerID?: string
    storeID?: string
    userData?: userData
    onChange: () => void
}

interface userData {
    employee_id_adviser: string, // 产康顾问id
    main_recover_id: string, // 主产康师id
    vice_recover_id: string, // 副产康师id
}

interface employee {
    "employee_id": string,
    "user_name": string
}

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}

const { Option } = Select

export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [adviserData, setAdviserData] = useState<employee[]>([])
    const [recoverData, setRecoverData] = useState<employee[]>([])

    useEffect(() => {
        if (prop.storeID) {
            form.setFieldsValue({
                employee_id_adviser: prop.userData?.employee_id_adviser,
                main_recover_id: prop.userData?.main_recover_id,
                vice_recover_id: prop.userData?.vice_recover_id
            })

            // 查询产康顾问列表
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: 4
                }

            }).then((res: any) => {
                res && setAdviserData(res)
            })

            // 查询产康师列表
            baseAxiosNoInfo('/global/employee_list_by_position', {
                params: {
                    department_id: prop.storeID,
                    position_number: 5
                }

            }).then((res: any) => {
                res && setRecoverData(res)
            })
        }
    }, [prop.storeID])

    const updateServiceInfo = (values: any) => {
        baseAxiosComplete.post('/chankang_center/customer/distribute_service_personnel', {
            customer_id: param.id,
            employee_id_adviser: values.employee_id_adviser, // 产康顾问id
            main_recover_id: values.main_recover_id, // 主产康师id
            vice_recover_id: values.vice_recover_id, // 副产康师id

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return (<Fragment>
        {/* 产康中心 -> 产康客户管理 -> 产康客户列表 -> 客户详情 -> 分配服务人员 */}
        <Button type="primary" style={{ marginLeft: 10 }} size="small" onClick={() => { setVisible(true) }}>分配服务人员</Button>

        <Modal title="分配服务人员" visible={visible} footer={false} onCancel={() => { setVisible(false) }} >
            <Form form={form} {...formItemLayout} onFinish={updateServiceInfo} >
                <Form.Item label="产康顾问" name="employee_id_adviser" rules={[{ required: true, message: '必须选择产康顾问' }]}>
                    <Select virtual={false}>
                        {adviserData.map((el: employee) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="主产康师" name="main_recover_id" >
                    <Select virtual={false}>
                        {recoverData.map((el: employee) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="副产康师" name="vice_recover_id" >
                    <Select virtual={false}>
                        {recoverData.map((el: employee) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </Fragment>)
}